export default __webpack_public_path__ + "new-submission-icon.png";